import React, { useRef } from "react";
import { Container, Box } from "@mui/material";
import Header from "./Header";
import Introduction from "./Introduction";
import GSIndicator from "./GSIndicator";
import PageHeader from "./PageHeader";
import GDPLines from "./GDPLines";
import Tabs from "./Tabs";
import RelatedResearch from "./RelatedResearch";
import FAQs from "./FAQs";
import Footer from "./Footer";
import { ScrollProvider } from "./ScrollContext";

export default function App() {
  const gsIndicatorRef = useRef(null);
  const gdplinesRef = useRef(null);
  const relatedResearchRef = useRef(null);
  const tabsRef = useRef(null);

  const scrollRefs = {
    gsIndicatorRef,
    gdplinesRef,
    relatedResearchRef,
  };

  return (
    <ScrollProvider value={scrollRefs}>
      <div>
        <Header />
        <PageHeader />
        {/* ✅ 其余组件缩窄居中 */}
        <Container>
          {/* ✅ 统一 className="component"，并调整间距 */}
          <Box className="component">
            <Introduction />
          </Box>

          <Box ref={gsIndicatorRef} className="component">
            <GSIndicator />
          </Box>

          <Box ref={gdplinesRef} className="component">
            <GDPLines />
          </Box>

          <Box ref={tabsRef} className="component">
            <Tabs />
          </Box>

          <Box className="component">
            <FAQs />
          </Box>

          <Box ref={relatedResearchRef} className="component">
            <RelatedResearch />
          </Box>
          <Box className="component">
            <Footer />
          </Box>
        </Container>
      </div>
    </ScrollProvider>
  );
}
